import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getHostPromoList = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/productivity-host/promotion/list?${queries}` });

  return data;
};

export default getHostPromoList;
